module.exports = __webpack_public_path__ + "img/why-us-img.2a4b63f3.jpg";